import React from "react";
import { VisibilityContext } from "react-horizontal-scrolling-menu";
import ImageIcon from '@mui/icons-material/Image';

export default function Card({
    itemId,
    selected,
    onClick,
    textureUrl,
  }) {
    const visibility = React.useContext(VisibilityContext);
  
    const visible = visibility.isItemVisible(itemId);
    console.log("derp: " + textureUrl);
    return (
      <div
        onClick={() => onClick()}
        role="button"
        style={{
          border: selected ? "1px solid #424253" : "1px solid #353542",
          background: selected ? "#424253" : "",
          display: "inline-block",
          margin: "0 10px",
          marginTop: '0.5rem',
          marginBottom: '0.3rem',
          width: 100,
          height: 100,
          borderRadius: '0.4rem',
          justifyContent: 'center',
          alignItems: 'center',
          gridColumn: 1 / 3,
          cursor: 'pointer'
        }}
        tabIndex={0}
        className="card"
      >
        {(textureUrl.startsWith('blob') || textureUrl.endsWith('.png') || textureUrl.endsWith('.gif') || textureUrl.endsWith('.jpg')) ?
        <img
          style={{
            width: `${100 - 5}px`,
            height: `${100 - 5}px`,
            margin: "2.5px 2.5px",
            display: "inline-block",
            borderRadius: '0.4rem',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            marginBottom: 5
          }}
          src={textureUrl}
        />
        :
        <ImageIcon style={{
          width: `${100 - 5}px`,
          height: `${100 - 5}px`,
          margin: "2.5px 2.5px",
          display: "inline-block",
          borderRadius: '0.4rem',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'pointer',
          marginBottom: 5,
          color: "#354253"
        }} />
        }
        <div
        style={{
          color: selected ? "white" : "#424253",
          textAlign: "center"
        }}
      >
        {textureUrl.substr(0, textureUrl.indexOf('.')).split('\\').pop().split('/').pop()}
        </div>
      </div>
    );
  }